import { Typography, Stack } from '@mui/material';

import React from 'react';

import { ImgTagComponent } from '../../common/utils/utilFunctions';

import styles from './PageTitle.module.scss';

type PageTitleProps = {
	text: {
		title?: string;
		body?: string | React.ReactElement;
		subTitle?: string;
		image?: string;
		gap?: number;
		isbreadCrumbs?: boolean;
	};
	childComponent?: React.ReactNode;
	titleSize?: number;
	className?: any;
	innerTextClass?: any;
};

const PageTitle: React.FC<PageTitleProps> = ({
	text,
	childComponent,
	titleSize = 36,
	className,
	innerTextClass,
}) => (
	<Stack className={styles['title-container']} gap={text.gap ? text.gap : 3}>
		<Stack direction="row" justifyContent="space-between">
			<Typography
				fontSize={titleSize}
				className={className !== '' ? className : styles['text-title']}
			>
				{text.title}
				{text.image && ImgTagComponent(text.image, 'downArrowWhite')}
			</Typography>
			{childComponent}
		</Stack>
		{text.body && (
			<Typography className={styles['text-subtitle']}>{text.body}</Typography>
		)}
		{text.subTitle && (
			<Typography className={innerTextClass || styles['display-title']}>
				{text.subTitle}
			</Typography>
		)}
	</Stack>
);
export default PageTitle;
